import React, { Dispatch, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import { Action } from 'typesafe-actions';
import { Redirect } from 'react-router-dom';
import { logoutRequest } from '../../../store/ducks/auth/actions';

const Logout: React.FC<any> = () => {
  const token = useSelector((state: ApplicationState) => state.auth.token);
  const dispatch = useDispatch<Dispatch<Action>>();

  useEffect(() => {
    dispatch(logoutRequest());
  }, [dispatch]);

  return <>{!token && <Redirect to={{ pathname: '/login' }} />}</>;
};

export default Logout;
